module.exports = __webpack_public_path__ + "static/media/img_Benchmarking306.7c18de4a.png";